export default {
  image: 'p1.jpg',
  productData: {
    name: 'Premiumsystem P1',
    shorthand: "P1",
    advantages: [
      "Streiflichtunempfindlich",
      "Sehr matte Oberfläche",
      "Risssicher",
      "Optisches Highlight"
    ],
    technical: [
      "Feuchtraum WO-I",
      "Glatte Flächen",
      "höchste Brandklassifizierung",
      "Glanzgrad stumpfmatt",
      "Erhöhte optische Ansprüche",
      "TÜV"
    ],
    systemStructure: [
      {
        type: 'subsurface',
        layer: 1,
        products: [0],
        selectedProduct: 0,
        changedProduct: false
      },
      {
        type: 'joints',
        layer: 2,
        products: [1],
        selectedProduct: 1,
        changedProduct: false
      },
      {
        type: 'surfaceFilling',
        layer: 3,
        products: [51, 52],
        selectedProduct: 51,
        changedProduct: false
      },
      {
        type: 'firstCoat',
        layer: 4,
        products: [10],
        selectedProduct: 10,
        changedProduct: false
      },
      {
        type: 'glue',
        layer: 5,
        products: [23],
        selectedProduct: 23,
        changedProduct: false
      },
      {
        type: 'wallCovering',
        layer: 6,
        products: [24, 25, 26],
        selectedProduct: 24,
        changedProduct: false
      },
      {
        type: 'finalCoatLayer1',
        layer: 7,
        products: [44, 12],
        selectedProduct: 44,
        changedProduct: false
      },
      {
        type: 'finalCoatLayer2',
        layer: 7,
        products: [44, 12],
        selectedProduct: 44,
        changedProduct: false
      }
    ],
    construction: {
      composition: [
        {
          title: { de: 'Systemgruppen' },
          output: 'Premiumsystem',
          type: 'systemGroup',
          value: 'systemgroup-4'
        },
        {
          title: { de: 'Räume' },
          output: 'Wohnräume',
          type: 'room',
          value: 'room-1'
        },
        {
          title: { de: 'Räume' },
          output: 'Bad',
          type: 'room',
          value: 'room-2'
        },
        {
          title: { de: 'Räume' },
          output: 'Flur',
          type: 'room',
          value: 'room-4'
        },
        {
          title: { de: 'Umwelt- und Gesundheitsaspekte' },
          output: 'Schadstoffgeprüft',
          type: 'environmentHealth',
          value: 'environmenthealth-1'
        },
        {
          title: { de: 'Umwelt- und Gesundheitsaspekte' },
          output: 'TÜV',
          type: 'environmentHealth', 
          value: 'environmenthealth-2'
        },
        {
          title: { de: 'Belastbarkeit' },
          output: 'Streiflichtunempfindlich',
          type: 'resilience', 
          value: 'resilience-2'
        },
        {
          title: { de: 'Belastbarkeit' },
          output: 'Desinfektionsmittelbeständig',
          type: 'resilience', 
          value: 'resilience-5'
        },
        {
          title: { de: 'Belastbarkeit' },
          output: 'Risssicher',
          type: 'resilience', 
          value: 'resilience-6'
        },
        {
          title: { de: 'Design / Oberfläche' },
          output: 'Matt',
          type: 'designSurface', 
          value: 'designsurface-1'
        },
        {
          title: { de: 'Design / Oberfläche' },
          output: 'Glatt',
          type: 'designSurface', 
          value: 'designsurface-6'
        },
        {
          title: { de: 'Design / Oberfläche' },
          output: 'Erhöhte optische Ansprüche',
          type: 'designSurface', 
          value: 'designsurface-8'
        },
        {
          title: { de: 'Verarbeitungszeit' },
          output: 'Stufe 2',
          type: 'processingTime', 
          value: 'processingtime-2'
        },
        {
          title: { de: 'Preisniveau' },
          output: '€€',
          type: 'priceLevel', 
          value: 'pricelevel-2'
        }
      ]
    }
  }
}
